import { UserAccountStatusEnum } from '@/lib/enum';
import { getTitleEnumValue } from '@/functions';
import { IHasClassName } from '@/interfaces';
import { cn } from '@/lib/utils';
import { Badge } from '../ui';

type TUser = {
  accountStatus?: UserAccountStatusEnum;
};

type TProps = IHasClassName & {
  isVisible?: (user: TUser) => boolean;
  title?: string;
  user?: TUser;
}

const BadgeUserAccountStatus = ({ user, title, isVisible, className }: TProps) => {

  if (!user?.accountStatus || (isVisible && !isVisible(user))) {
    return <></>;
  }

  return (
    <Badge
      variant={'outline'}
      title={title}
      className={cn(
        'text-sm border-0 text-white',
        user.accountStatus === UserAccountStatusEnum.ADMIN_DELETED && 'bg-red-600',
        user.accountStatus === UserAccountStatusEnum.HIDDEN && 'bg-neutral-500',
        user.accountStatus === UserAccountStatusEnum.PAUSED && 'bg-yellow-500',
        user.accountStatus === UserAccountStatusEnum.ACTIVE && 'bg-green-500',
        user.accountStatus === UserAccountStatusEnum.DELETED && 'bg-red-500',
        user.accountStatus === UserAccountStatusEnum.SUSPENDED && 'bg-amber-500',
        user.accountStatus === UserAccountStatusEnum.BANNED && 'bg-red-500',
        className
      )}>
      {getTitleEnumValue('UserAccountStatusEnum', user.accountStatus)}
    </Badge>
  );

};

export default BadgeUserAccountStatus;
